
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "AVAROHRICOAA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/AVAROHRICOAA.vue